import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const WEBVIEW_DEVICE_MODELS = new Set(['aapl', 'android']);

const isWebviewDeviceModel = deviceModel => WEBVIEW_DEVICE_MODELS.has(deviceModel);

export const useIsInWebview = () => {
  const [searchParams] = useSearchParams();
  const [isInWebview, setIsInWebview] = useState(() =>
    isWebviewDeviceModel(searchParams.get('device_model')),
  );

  useEffect(() => {
    const inWebview = isWebviewDeviceModel(searchParams.get('device_model'));
    setIsInWebview(inWebview);
  }, [searchParams]);

  return isInWebview;
};
